import { NEW_PATH, USERS_PATH } from "../../../constants/RoutesConstants";
import React, { useEffect } from "react";

import LinkHref from "../../components/Buttons/LinkHref";
import Props from "./props";
import { useAppTitle } from "../../../state/hooks/MainHooks/useAppTitle";

const All: React.FC<Props> = props => {
    const { setAppTitle } = useAppTitle();
    useEffect(() => {
        setAppTitle(props.title);
        return () => {
            setAppTitle("");
        };
    }, [setAppTitle, props.title]);
    return (
        <div>
            <h1>All [User]</h1>
            <LinkHref to={`${USERS_PATH}/user-slug-1`}>Single</LinkHref>
            <LinkHref to={`${USERS_PATH}${NEW_PATH}`}>New</LinkHref>
        </div>
    );
};

export default All;
